// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1_XLJ","innerContent":"styles__innerContent___23F_7","scroll-navigation":"styles__scroll-navigation___3Bi9A","prev":"styles__prev___FIn_e","next":"styles__next___2dx2J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalScroll/styles.scss
// module id = 340
// module chunks = 0